/**
 * How far back the calendar, the dashboard and the events feed load history.
 *
 * One knob on purpose: the calendar listener writes into the dashboard's appointment cache, and
 * the calendar's back arrow stops at this same boundary, so a narrower window anywhere would
 * quietly shrink the others. Events follow the same rule — last three months plus everything
 * ahead.
 *
 * It bounds which documents are watched, not how. Listeners stay live, so anything someone adds
 * inside the window still reaches every open client immediately.
 */
export const HISTORY_WINDOW_MONTHS = 3;

/** First day of the oldest month those views load and let the user reach. */
export function getHistoryFloor(now: Date = new Date()): Date {
  return new Date(now.getFullYear(), now.getMonth() - HISTORY_WINDOW_MONTHS, 1);
}

export type TimeRangeFilter = '3months' | '6months' | '9months' | 'alltime';

export function getCutoffDate(range: TimeRangeFilter): Date {
  const now = new Date();
  switch (range) {
    case '6months': {
      const d = new Date(now);
      d.setMonth(d.getMonth() - 6);
      return d;
    }
    case '9months': {
      const d = new Date(now);
      d.setMonth(d.getMonth() - 9);
      return d;
    }
    case 'alltime':
      return new Date(0);
    case '3months':
    default: {
      const d = new Date(now);
      d.setMonth(d.getMonth() - 3);
      return d;
    }
  }
}
